import { Input, InputGroup } from '@/components/base/input'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { useContext, useEffect } from 'react'
import { useState } from 'react'
import { useLocale } from '../useLocale'

interface CurrencyProps {
  value: number
  onChange: (value: number) => void
  disabled: boolean
  invalid: boolean
}

export const WeightInput = ({ value, onChange, disabled, invalid }: CurrencyProps) => {
  const [internalValue, setInternalValue] = useState(value.toFixed(2))
  const { currentCompany } = useContext(CurrentTenantContext)
  const { units } = useLocale(currentCompany?.locale)

  useEffect(() => {
    if (parseFloat(internalValue || '0') != value) setInternalValue(value.toFixed(2))
  }, [value, internalValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value)
    onChange(parseFloat(e.target.value || '0'))
  }

  return (
    <InputGroup>
      <Input
        disabled={disabled}
        invalid={invalid}
        min={0}
        step={0.01}
        type="number"
        value={internalValue}
        onChange={handleChange}
      />
      <span className="text-zinc-500 text-sm/4" data-slot="icon">{units.weight}</span>
    </InputGroup>
  )
}
